import { EditForm } from '@/features/members';

export default function TeamMemberEditRoute() {
  return <EditForm />;
}
